export default __webpack_public_path__ + "static/media/subs-image-1.d6e86184.webp";